//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import validation, { required, min , email } from 'src/util/validation';

export default {
	name: 'RegisterPage',
	mixins: [validation],
	data() {
		return {
			email: this.$store.state.email || '',
			password: '',
			showText: false,
			registerIsRunning: false,
			emailExists: false,
		};
	},
	validation() {
		return {
			email: [
				email('Keine gültige E-Mail!'),
				required('Bitte geben Sie Ihre E-Mail Adresse ein!'),
				() => !this.emailExists || 'Diese E-Mail Adresse existiert bereits!',
			],
			password: [
				required('Bitte geben Sie Ihr Passwort ein!'),
				min(6, 'Das Passwort muss mindestens 6 Zeichen lang sein!'),
			],
		};
	},
	watch: {
		email(email) {
			this.$store.state.email = email;
		},
	},
	methods: {
		async register() {
			this.registerIsRunning = true;

			try {
				await this.$store.dispatch('auth/register', {
					email: this.email,
					password: this.password,
				});
				this.$q.notify.success('Sie wurden erfolgreich registriert!');
				await this.$store.dispatch('auth/login', {
					email: this.email,
					password: this.password,
				});
				this.$router.replace('/');
			} catch (error) {
				switch (error.response.status) {
					case 409:
						this.emailExists = true;
						break;
				}
				await this.validate();
				this.emailExists = false;
			}

			this.registerIsRunning = false;
		},
	},
};
